/* eslint-disable */
export default {
  _LvlBtn1: 'LvlBtn1',
  _LvlBtn2: 'LvlBtn2',
  _LvlBtn3: 'LvlBtn3',
  _LvlBtn4: 'LvlBtn4',
  _LvlBtn5: 'LvlBtn5',
}